import React from 'react';
import PropTypes from 'prop-types';
import * as utils from './../../utilities/calendarUtilities';
import { pairings } from './../../data/constants/index';
import { useLanguage } from '../../context/LanguageContext';

const Pairing = (props) => {
  const { labels } = useLanguage();
  const pairingStrings = labels.pairingStrings || {};
  const commonLabels = labels.commonLabels || {};
  const { pairing, reportMode } = props;
  const report = utils.getUTC(props.startDate);
  const release = utils.getUTC(props.endDate);
  const restAfterTrip = pairing.restAfterTrip === 0 ? pairingStrings.NOT_SET : utils.formatMinutesToHoursWithMinutes(pairing.restAfterTrip);

  const tableHeads = pairingStrings.theads.map(
    (thead, i) => {
      const myKey = i;
      return (<th key={myKey}>{thead}</th>);
    }
  );

  const tableCells = pairing.pairingDetails.map(
    (detail, i) => {
      const myKey = i;
      const departure = utils.getUTC(detail.relativeStartFromStation);
      const arrival = (detail.relativeEndtoStation) ?
        utils.getUTC(detail.relativeEndtoStation) : null;

      if (detail.type === pairings.TYPES.LAYOVER) {
        return (
          <tr key={myKey} className="layover-row">
            <td colSpan="9">
              <span>{`${pairingStrings.LAYOVER_IN} ${detail.fromStationId} | ${commonLabels.dates.jsweekdayslowercase[departure.getDay()]}
                ${utils.getFormattedPairingDate(departure.getMonth(), departure.getDate())}
                ${utils.getFormattedPairingTime(departure.getHours(), departure.getMinutes())}
                (${utils.formatMinutesToHoursWithMinutes(detail.layOverTimeInMin)}) `} <br /> {detail.hotelName ? `  ${pairingStrings.HOTEL} ${detail.hotelName}` : ''} </span>
            </td>
          </tr>
        );
      }

      const blockTimeInMin = utils.formatMinutesToHoursWithMinutes(detail.blockTimeInMin)
      const timeAfterInMin = utils.formatMinutesToHoursWithMinutes(detail.timeAfterInMin)
      const dtm = utils.formatMinutesToHoursWithMinutes(detail.dutyTimeInMin)
      const credits = utils.formatMinutesToHoursWithMinutes(detail.credits)
      const checkRenderTime = time => time === "00h00" ? null : time

      return (
        <tr key={myKey}>
          <td>
            {(detail.status === pairings.FLIGHTS.ACTIVE || detail.status === pairings.FLIGHTS.DEADHEAD) ?
              <div className={`plane ${(detail.status === pairings.FLIGHTS.ACTIVE) ? 'active' : ''}`} /> : ''}
            {detail.flightNumber}
          </td>{/* FLIGHT */}
          <td>
            <span className="station">{detail.subEquipmentId}</span>
          </td>
          <td>
            <span className="station">{detail.fromStationId}</span> {` ${commonLabels.dates.jsweekdayslowercase[departure.getDay()]}
             ${utils.getFormattedPairingDate(departure.getMonth(), departure.getDate())}
             ${utils.getFormattedPairingTime(departure.getHours(), departure.getMinutes())}`}
          </td>{/* DEPARTURE */}
          <td>
            <span className="station">{detail.toStationId}</span>
            {(arrival) ?
              ` ${commonLabels.dates.jsweekdayslowercase[arrival.getDay()]}` :
              ''
            }
            {(arrival) ?
              ` ${utils.getFormattedPairingDate(arrival.getMonth(), arrival.getDate())}` :
              ' '
            }
            {(arrival) ?
              ` ${utils.getFormattedPairingTime(arrival.getHours(), arrival.getMinutes())}` :
              ''
            }
          </td>{/* ARRIVAL */}
          <td>{checkRenderTime(blockTimeInMin)}</td>{/* BLOCK */}
          <td>{checkRenderTime(credits)}</td>{/* CREDIT */}
          <td>{checkRenderTime(timeAfterInMin)}</td>{/* TOG */}
          <td>{checkRenderTime(dtm)}</td>{/* DTM */}
        </tr>
      );
    }
  );
  return (
    <div className={!reportMode ? "Pairing-Table" : "Pairing-Table-Report" }>
      <div className="main-header">
        <div className="data-block">
          <div className="title">
            {pairingStrings.PAIRING}
          </div>
          <div className="details">
            {props.name}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {pairingStrings.REPORT}
          </div>
          <div className="details">
            {utils.getFormattedDateNoYear(report)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {pairingStrings.RELEASE}
          </div>
          <div className="details">
            {utils.getFormattedDateNoYear(release)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {pairingStrings.BLOCK}
          </div>
          <div className="details">
            {utils.formatMinutesToHoursWithMinutes(pairing.totalBlockTimeInMin)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {!reportMode ? pairingStrings.BLOCK_IN_PERIOD : 'IPB'}
          </div>
          <div className="details">
            {utils.formatMinutesToHoursWithMinutes(pairing.blockTimeInPeriodInMin)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {!reportMode ? pairingStrings.INPERIOD_CREDIT : 'IPC'}
          </div>
          <div className="details">
            {utils.formatMinutesToHoursWithMinutes(pairing.creditInPeriodInMin)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {!reportMode ? pairingStrings.TOTAL_CREDIT : 'TC'}
          </div>
          <div className="details">
            {utils.formatMinutesToHoursWithMinutes(pairing.totalCreditInMin)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {pairingStrings.REST}
          </div>
          <div className="details">
            {restAfterTrip}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {pairingStrings.TAFB}
          </div>
          <div className="details">
            {utils.formatMinutesToHoursWithMinutes(pairing.timeAwayFromBaseInMin)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {pairingStrings.DAYS}
          </div>
          <div className="details">
            {props.days}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {pairingStrings.CREW_COMPOSITION}
          </div>
          <div className="details">
            {pairing.crewComposition}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {!reportMode ?pairingStrings.AVAILABILITY : 'AVAIL'}
          </div>
          <div className="details">
            {props.nbSeniorOutbids} {pairingStrings.AVAILABILITY_DETAIL}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {!reportMode ? pairingStrings.ATTRIBUTES : 'ATTR'}
          </div>
          <div className="details">
            {props.attributes}
          </div>
        </div>
      </div>
      <table>
        <thead>
        <tr>{tableHeads}</tr>
        </thead>
        <tbody>
        {tableCells}
        </tbody>
      </table>
    </div>
  );
};

Pairing.defaultProps = {
  pairing: {},
  name: '',
  days: 0,
  startDate: 0,
  endDate: 0,
  attributes: ""
};

Pairing.propTypes = {
  pairing: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  days: PropTypes.number.isRequired,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  attributes: PropTypes.string.isRequired
};

export default Pairing;
